import organizationApiFetch from "./organizationApiFetch";

const STORE_SERVER_URL = process.env.REACT_APP_STORE_SERVER_URL || "http://localhost:8085";

async function StoreApiFetch(path, options = {}) {
    const {
        method = "GET",
        body = null,
        headers = {},
    } = options;
    
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    
    const requestHeaders = {
        "Content-Type": "application/json",
        ...headers,
    };

    const response = await organizationApiFetch(`${STORE_SERVER_URL}/service${normalizedPath}`, {
        method,
        headers: requestHeaders,
        body,
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch (error) {
        console.error("Error parsing JSON response:", error);
    }

    if (!response.ok) {
        const requestError = new Error(
            payload.error || payload.message || "An error occurred while fetching data."
        );
        requestError.status = response.status;
        requestError.details = payload.details;
        throw requestError;
    }

    return payload;
} 

export async function getProducts() {
    return await StoreApiFetch("/products", {
        method: "GET",
    });
}

export async function getProductById(productId) {
    return await StoreApiFetch(`/products/${productId}`, {
        method: "GET",
    });
}




export async function getPaymentConfig() {
    return await StoreApiFetch("/payments/config", {
        method: "GET",
    });
}

export async function bookAppointment(appointmentData) {
    return await StoreApiFetch("/payments/appointments", {
        method: "POST",
        body: { 
            discount_code: appointmentData.discount_code,
            booking_request_id: appointmentData.booking_request_id,
            user_id: appointmentData.user_id,
            services: appointmentData.services,
            product_id: appointmentData.product_id,
            attribute_ids: appointmentData.attribute_ids,
            attribute_value_ids: appointmentData.attribute_value_ids,
            customer_phone: appointmentData.customer_phone,
            customer_email: appointmentData.customer_email,
            customer_first_name: appointmentData.customer_first_name,
            customer_last_name: appointmentData.customer_last_name,
            date: appointmentData.date,
            start_time: appointmentData.start_time,
            end_time: appointmentData.end_time,
            appointment_title: appointmentData.appointment_title,
            appointment_attributes: appointmentData.appointment_attributes,
            questionnaire_answers: appointmentData.questionnaire_answers,
        },
    });
}

export async function previewDiscount(code) {
    return await StoreApiFetch("/discount/preview", {
        method: "POST",
        body: { code },
    });
}

export async function confirmCardSetup(setupIntentId) {
    return await StoreApiFetch("/payments/setup/confirm", {
        method: "POST",
        body: {
            setup_intent_id: setupIntentId,
        },
    });
}

export async function lookupCustomer({email, phone}) {
    return await StoreApiFetch("/customer/lookup", {
        method: "POST",
        body: { email, phone }
    });
}

export async function getQuestionnaire() {
    return await StoreApiFetch("/checkoutpage/questionnaire", {
        method: "GET"
    });
}